module.exports = __webpack_public_path__ + "1804605f2531c4d72b3342fbbabb2e64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/polar.png
// module id = 1833
// module chunks = 1